/* WF-047 · /creer-mon-espace — where an invitation link lands (#token=, 01 §1.2). V1: the same exchange as the sign-in
   door, then the guide (/guide) — the espace is prepared by us for the first client; the signup form (POST /app/signup) is
   a later row. Without a token the page says so and offers the sign-in door. A dead invitation is said in the contract's
   words (authLines: invite_expired). */
import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Note } from '@/ui'
import { authLines, exchangeToken, readFragmentToken, SIGN_IN } from '@/lib/auth'
import { Door } from './Door'

export default function CreerMonEspace() {
  const navigate = useNavigate()
  const { hash } = useLocation()
  const [busy, setBusy] = useState(false)
  const [line, setLine] = useState<string | null>(null)

  useEffect(() => {
    const t = readFragmentToken()
    if (!t) return
    setBusy(true); setLine(null)
    exchangeToken(t)
      .then(() => navigate('/guide', { replace: true }))
      .catch(e => { setLine(authLines(e)); setBusy(false) })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash])

  return (
    <Door testid="creer-espace">
      <div>
        <h1 className="t-page" style={{ margin: 0 }}>Votre espace marchand</h1>
        <p className="t-body" style={{ margin: '6px 0 0', color: 'var(--bmr-text-muted)' }}>Nous préparons votre espace avec vous.</p>
      </div>
      {busy && <p className="t-body" style={{ margin: 0 }} data-testid="connexion-ligne" aria-live="polite">Ouverture de votre espace…</p>}
      {line && <Note tone="crit" data-testid="connexion-ligne">{line}</Note>}
      {!busy && (
        <div className="card" style={{ display: 'grid', gap: 12 }}>
          <p className="t-body" style={{ margin: 0 }}>Votre espace est préparé par nos soins. Le lien d’invitation reçu par e-mail l’ouvre, depuis ce téléphone ou cet ordinateur.</p>
          <p className="f-help" style={{ margin: 0 }}>Un accès existant retrouve le même établissement et ses brouillons.</p>
          <div><Link className="btn btn-quiet" to={SIGN_IN}>Retrouver mon espace</Link></div>
        </div>
      )}
    </Door>
  )
}
